import { NavLink } from 'react-router-dom'
import { ROUTES } from '@constants'
import images from '@assets/images'
import './Navbar.css'

const NAV_ITEMS = [
  { label: 'Tổng Quan', path: ROUTES.HOME },
  { label: 'Mặt Bằng',  path: ROUTES.MAT_BANG },
  { label: 'Tiện Ích',  path: ROUTES.TIEN_ICH },
  { label: 'Gallery',   path: ROUTES.GALLERY },
  { label: 'Brochure',  path: ROUTES.BROCHURE },
]

function Navbar() {
  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      {/* Logo */}
      <NavLink to={ROUTES.HOME} className="navbar__logo" aria-label="Fenica – Trang chủ">
        <img src={images.logo} alt="Fenica Logo" />
      </NavLink>

      {/* Navigation links */}
      <ul className="navbar__menu" role="list">
        {NAV_ITEMS.map(({ label, path }) => (
          <li key={path} className="navbar__item">
            <NavLink
              to={path}
              end={path === ROUTES.HOME}
              className={({ isActive }) =>
                `navbar__link${isActive ? ' navbar__link--active' : ''}`
              }
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Navbar
